import * as React from 'react';
import { Button, Modal, Select } from 'antd';
import { useRef, useState } from 'react';
import { Company } from '../../../models/company-interface';

const { Option } = Select;

type Props = {
  isVisible: boolean,
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>,
  handleSubmit: Function,
  isLoading: boolean,
  selectedRowKeys: Company[]
}

const CreateDeletionRequestsModal: React.FC<Props> = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  isLoading,
  selectedRowKeys
}) => {
 
  return (
    <Modal
      centered
      title="Request Deletion of Companies"
      visible={isVisible}
      onCancel={() => setIsVisible(false)}
      footer={[
        <Button id="cancel" type="text" key="cancel" onClick={() => setIsVisible(false)}>
          Cancel
        </Button>,
        <Button id={`submitButton`} type="primary" key="submit" htmlType="submit" form="grantAccessForm" loading={isLoading} onClick={() => handleSubmit()}>
          Yes, Submit Request
        </Button>
      ]}
      destroyOnClose
    >
      <p>Are you sure you want to request the deletion of the selected companies: <b>{selectedRowKeys.map(x => x.name).join(', ')}</b></p>
    </Modal>
  )
};

export default CreateDeletionRequestsModal;